import React, { useState, useEffect } from "react";
import "./Shop.css";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import Coins from "../../Components/Coins/Coins";
import Alert from "../../Components/Alert/Alert";
import BottomBar from "../../Components/BottomBar/BottomBar";
import Loading from "../../Components/Loading/Loading";
import { FaHeart } from "react-icons/fa";
import { AiOutlineSearch } from "react-icons/ai";
import useCart from "../../Hooks/useCart";
import { useAuth } from "../../AuthContext";
import useShopCategories from "../../Hooks/useShopCategories";
import { useNavigate, Link } from "react-router-dom";
import ShopCard from "../../Components/ShopCard/ShopCard";
import CartIcon from "../../Components/CartIcon/CartIcon";

export default function Shop() {
  const navigate = useNavigate();
  const { userToken } = useAuth();
  const { cart } = useCart(userToken);
  const [isLoading, setIsLoading] = useState(true);
  const { shopCategories } = useShopCategories(userToken, setIsLoading);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const showAlertHandler = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("به زودی");
  };

  const handleCategoryClick = (category) => {
    if (category.has_child) {
      navigate("/productsCategory", { state: { categorySlug: category.slug } });
    } else {
      navigate("/partialProducts", { state: { categorySlug: category.slug } });
    }
  };

  useEffect(() => {
    localStorage.removeItem("attribute filters");
    localStorage.removeItem("price filters");
    localStorage.removeItem("product search value");
  }, []);

  const openShopSearch = () => {
    navigate("/productsSearch", { state: { label: "shop"  } });
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <div className="shopHeaderRight centeredFlex">
              <CartIcon {...cart} />
              <Link to="/favorites" className="link">
                <FaHeart className="favoriteIcon" />
              </Link>
              <AiOutlineSearch
                className="shopSearchIcon"
                onClick={openShopSearch}
              />
              <Coins onShowAlert={showAlertHandler} />
            </div>
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="scroll shopContent centeredFlex">
            <div className="shoppingCartBanner centeredFlex responsiveWidth">
              <div className="shoppingCartBannerTop centeredFlex">
                <p>فروشگاه رِدرُز</p>
                <div className="redroseShopText centeredFlex">
                  <p>Red</p>
                  <p>Rose</p>
                </div>
              </div>
              <div className="shoppingCartBottom centeredFlex">
                <span>همین حالا سفارش بده!</span>
              </div>
            </div>
            {isLoading ? (
              <Loading />
            ) : (
              <div className="shopCategories">
                {shopCategories !== null &&
                  shopCategories.length > 0 &&
                  shopCategories.map((category) => (
                    <ShopCard
                      label="category"
                      key={category.id}
                      {...category}
                      onShopCardClick={() => handleCategoryClick(category)}
                    />
                  ))}
              </div>
            )}
          </div>
          <Alert alertText={alertText} showAlert={showAlert} />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
